module.exports = __webpack_public_path__ + "media/images/lb/100-190a5408489dfe0e73cf12ff11675e24.svg";